import useCrud from 'hooks/useCrud';
import { useCallback } from 'react';
import {
  list,
  fetch,
  create,
  update,
  updateStatus as updateStatusApi,
  del,
} from 'services/api/storeGroup';

function useStoreGroup() {
  const { setList, ...others } = useCrud({
    read: fetch,
    readList: list,
    create,
    update,
    del,
  });

  const updateStatus = useCallback(
    (...props: Parameters<typeof updateStatusApi>) => {
      const [body] = props;

      return updateStatusApi(body).then(() => {
        const { id, status } = body;

        setList((list = []) => {
          const targetIndex = list.findIndex((item) => item.id === id);

          if (targetIndex === -1) {
            return list;
          }

          // eslint-disable-next-line no-param-reassign
          list[targetIndex] = {
            ...list[targetIndex],
            id,
            status,
          };

          return [...list];
        });
      });
    },
    [setList],
  );

  return {
    setList,
    updateStatus,
    ...others,
  };
}

export default useStoreGroup;
